import { render, staticRenderFns } from "./DashboardNavigationButton.vue?vue&type=template&id=21925b42&scoped=true"
import script from "./DashboardNavigationButton.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardNavigationButton.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DashboardNavigationButton.vue?vue&type=style&index=0&id=21925b42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21925b42",
  null
  
)

export default component.exports